import type { MassAction } from "./MassAction";

export const massActionStatusLabels: Record<MassAction["status"], string> = {
  in_progress: "In Progress",
  done: "Done",
  failed: "Failed",
  queued: "Queued",
};
